import InteracCircle from '@/assets/interac-circle.png'
import { Button } from '@/components/Button/Button'
import { Pages, usePageStateStore } from '@/reducers'
import { track } from '@/utils/analytics'

type InteracRequestInstructionsProps = {
  orderId: string
  wallet: string
}

export const InteracRequestInstructions = ({
  wallet,
  orderId,
}: InteracRequestInstructionsProps) => {
  const goToPage = usePageStateStore.use.goToPage()
  return (
    <div
      data-testid="container-interac-instructions"
      className="flex flex-col gap-5"
    >
      <h1 data-testid="text-interac-title" className="text-2xl">
        Almost Done...
      </h1>
      <div
        data-testid="container-interac-details"
        className="flex justify-stretch"
      >
        <div data-testid="container-interac-order" className="flex-grow">
          <div data-testid="text-interac-order-label">Order ID</div>
          <div data-testid="text-interac-order-value">{orderId}</div>
        </div>
        <div data-testid="container-interac-wallet" className="flex-grow">
          <div data-testid="text-interac-wallet-label">Adding to</div>
          <div data-testid="text-interac-wallet-value">{wallet}</div>
        </div>
      </div>
      <div data-testid="container-interac-method">
        <div data-testid="text-interac-method-label">Receive via</div>
        <div
          data-testid="container-interac-method-details"
          className="flex gap-2 items-start"
        >
          <img data-testid="img-interac-logo" src={InteracCircle} width={20} />
          <div>
            <div data-testid="text-interac-method-name">
              Request Money Transfer (RMT)
            </div>
            <div data-testid="text-interac-provider" className="text-xs">
              Interac
            </div>
          </div>
        </div>
      </div>
      <Button
        data-testid="btn-interac-start-over"
        onClick={() => {
          track('start_over_clicked', { from: 'interac', tx_id: orderId })
          goToPage(Pages.CALC)
        }}
      >
        Start over
      </Button>
    </div>
  )
}
